import React from 'react'
import PropTypes from 'prop-types'
import MenuOverlay from './MenuOverlay'

/**
* Generic Sidebar Component.
*
* Sidebar component currently only supports left pull out sidebars, but this
* could be updated in the future to have sidebars from all sides of the screen.
*/
class MobileSidebar extends React.Component {
  constructor(props) {
    super(props)

    this.escapeKeyPress = this.escapeKeyPress.bind(this)
  }

  /**
  * Adds or removes behavior based on if the sidebar is about to be opened, or
  * closed. Current functionality includes:
  * - Esc key to close sidebar.
  * - Stop scrolling of background while sidebar is open.
  * - Toggle visibility of CS chat box.
  */
  componentWillReceiveProps(nextProps) {
    const context = document.querySelector(this.props.context)

    // Sidebar is going to open
    if (!this.props.isOpen && nextProps.isOpen) {
      // Add Esc key listener to close sidebar.
      window.addEventListener('keydown', this.escapeKeyPress, false)

      // Stop user from being able to scroll context.
      if (context) {
        context.style.overflowY = 'hidden'
      }

      // Hide the chat button since its z-index can't be trumped.
      if (window.CustomerSupport) {
        window.CustomerSupport.closeChat()
        window.CustomerSupport.hideChatBubble()
      }
    }

    // Going to Close
    if (this.props.isOpen && !nextProps.isOpen) {
      // Remove Esc key listener to close sidebar.
      window.removeEventListener('keydown', this.escapeKeyPress)

      // Allow context to scroll again.
      if (context) {
        context.style.overflowY = 'inherit'
      }

      // Show the chat button again.
      if (window.CustomerSupport) {
        window.CustomerSupport.showChatBubble()
      }
    }
  }

  /**
  * Keypress Event Handler. Checks to see if the Esc key was pressed. Once the
  * Esc key is pressed, the sidebar should be closed.
  */
  escapeKeyPress(e) {
    if (e.keyCode === 27) {
      return this.props.toggleSidebar('Escape Key')
    }
  }

  render() {
    return (
      <div
        className={`sidebar is-${this.props.side}-sidebar ${this.props.isOpen ? 'is-open' : 'is-closed'}`}
        aria-hidden={!this.props.isOpen}
      >
        <MenuOverlay
          isVisible={this.props.isOpen}
          onClick={() => this.props.toggleSidebar('Overlay')}
          zIndex={5}
        />
        <div className="sidebar-content">
          { this.props.children }
        </div>
      </div>
    )
  }
}

MobileSidebar.defaultProps = {
  isOpen: false,
  side: 'left',
  context: 'body',
}

MobileSidebar.propTypes = {
  isOpen: PropTypes.bool,
  toggleSidebar: PropTypes.func.isRequired,
  side: PropTypes.string,
  context: PropTypes.string,
}

export default MobileSidebar
